export const TABLE = 'Table';
export const NEW_TABLE = 'New Table';
export const COMMENTS = 'Comments';
export const COMMENTS_DOMAIN_CODE = 'CO';
export const LOGS = 'Logs';

export const COMMENT = 'Comment';
